import { defineComponent as _defineComponent } from 'vue'
import Vue, {computed, getCurrentInstance, onMounted} from 'vue';
import {SimulationProductType, useSimulationStore} from '@/components/calculator/services/SimulationStore';
import {useDealForm, useFormNavigation} from '@/components/calculator/form/useSimulationForm';
import SimulationFormInfoPanel from '@/components/calculator/form/SimulationFormInfoPanel.vue';
import ChangesDetection from '@/components/commons/ChangesDetection.vue';
import SimulationNavigation from '@/components/calculator/form/SimulationNavigation.vue';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';
import SimulationUserDataNotice from '@/components/calculator/form/SimulationUserDataNotice.vue';
import AlertMessage from '@/components/commons/message/AlertMessage.vue';
import {AlertType} from '@/models/enums/AlertType';
import {ProductType} from '@/commons/enums/ProductType';
import {CrmModules} from '@/types/CrmModules';
import {debouncedAtInput} from '@/services/utils/BasicUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'SimulationFormWrapper',
  setup(__props) {

const instance = getCurrentInstance()?.proxy;
const simulationStore = useSimulationStore();
const {fetchDeal,} = useDealForm();
const formNavigation = useFormNavigation();

const updateSimulation = simulationStore.debouncedUpdateSimulation();

const onFormChange = async() => {
  const simulationForm: any = (instance?.$refs.changesDetection as Vue).$refs.FORM_NAME;
  const isValid: boolean = simulationForm?.validate();
  simulationStore.setIsFormValid(isValid);
  if (simulationForm && !isValid) {
    console.error('form invalid');
    return;
  }
  updateSimulation();
};

onMounted(async() => {
  await fetchDeal();
  if (!hasAccessToCurrentSimulation.value) {
    return
  }
  await simulationStore.createOrUpdateSimulation();
});

const accessMessage: Partial<Record<SimulationProductType, string>> = {
  [ProductType.CASH]: I18NGetter().useSimulationFormWrapper.NO_ACCESS_TO_CASH_SIM,
}

const productTypeToModuleMap: Record<SimulationProductType, CrmModules> = {
  [ProductType.CASH]: CrmModules.CASH_COMPARISON_TOOL,
  [ProductType.MORTGAGE]: CrmModules.MORTGAGE_COMPARISON_TOOL,
}

const hasAccessToCurrentSimulation = computed<boolean>(() => {
  return !!instance?.$user.canAccessModule[productTypeToModuleMap[simulationStore.productType!]]
})

const getAccessMessage = computed<string>(() => {
  return accessMessage[simulationStore.productType!] || ''
})

return { __sfc: true,instance, simulationStore, fetchDeal, formNavigation, updateSimulation, onFormChange, accessMessage, productTypeToModuleMap, hasAccessToCurrentSimulation, getAccessMessage, SimulationFormInfoPanel, ChangesDetection, SimulationNavigation, I18NGetter, SimulationUserDataNotice, AlertMessage, AlertType }
}

})